import React from "react";
import BorderWrapper from "src/components/atoms/BorderWrapper";
import AgentContent from "src/components/atoms/AgentContent";

const AgentCard = (props) => {
  return (
    <BorderWrapper styles="w-44 md:w-full rounded-xl drop-shadow-md py-2 flex flex-col items-center">
      <AgentContent {...props} />
    </BorderWrapper>
  );
};

export default AgentCard;
